import { render } from "./SelectRelationships.vue?vue&type=template&id=e5c7f664&ts=true"
import script from "./SelectRelationships.vue?vue&type=script&lang=ts"
export * from "./SelectRelationships.vue?vue&type=script&lang=ts"

import exportComponent from "/home/uatcomp/public_html/wizards/travel-insurance-wizard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__